<template>
    <div>
        <updatesModal ref="elemSelected" v-if="validateUser()"></updatesModal>
        <section class="cl-header">
            <div class="cl-top-vector">
                <div class="cl-vector"></div>
            </div>
            <div class="cl-right-vector">
                <div class="cl-vector-1"></div>
            </div>
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="cl-banner-text">
                            <div class="banner-heading">Are your students ready for the future?</div>
                            <div class="banner-sub-heading">
                                Join our platform and streak your students to success and
                                help them in their career journey through our campus hiring programs.
                            </div>
                        </div>
                        <!--            <div class="get-started-btn">-->
                        <!--              <a href="/" class="cta">-->
                        <!--                <span>GET STARTED</span>-->
                        <!--                <svg width="13px" height="10px" viewBox="0 0 13 10">-->
                        <!--                  <path d="M1,5 L11,5"></path>-->
                        <!--                  <polyline points="8 1 12 5 8 9"></polyline>-->
                        <!--                </svg>-->
                        <!--              </a>-->
                        <!--            </div>-->
                    </div>
                </div>

                <div class="row">
                    <div class="stats-ey">
                        <div class="col-md-3 col-sm-6">
                            <div class="stat-box">
                                1500+ <p>Companies</p>
                                <span><img src="/images/college-landing-page/companies.png" alt=""></span>
                            </div>
                        </div>
                        <div class="col-md-3 col-sm-6">
                            <div class="stat-box">
                                50000+ <p>Jobs</p>
                                <span><img src="/images/college-landing-page/jobs.png" alt=""></span>
                            </div>
                        </div>
                        <div class="col-md-3 col-sm-6">
                            <div class="stat-box">
                                15000+ <p>Internships</p>
                                <span><img src="/images/college-landing-page/internship.png" alt=""></span>
                            </div>
                        </div>
                        <div class="col-md-3 col-sm-6">
                            <div class="stat-box">
                                100+ <p>Colleges</p>
                                <span><img src="/images/college-landing-page/internship.png" alt=""></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--            <education-loan-webinar></education-loan-webinar>-->
            <!--            <webinar-widget></webinar-widget>-->
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h1 class="main-heading cater-heading">Who do we cater ?</h1>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-2 col-sm-4">
                        <div class="cater-box">
                            <div class="cater-icon">
                                <img src="/images/college-landing-page/school2.png" alt="">
                            </div>
                            <div class="cater-name">
                                Schools
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2 col-sm-4">
                        <div class="cater-box">
                            <div class="cater-icon">
                                <img src="/images/college-landing-page/college2.png" alt="">
                            </div>
                            <div class="cater-name">
                                College
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2 col-sm-4">
                        <div class="cater-box">
                            <div class="cater-icon">
                                <img src="/images/college-landing-page/university2.png" alt="">
                            </div>
                            <div class="cater-name">
                                University
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2 col-sm-4">
                        <div class="cater-box">
                            <div class="cater-icon">
                                <img src="/images/college-landing-page/student2.png" alt="">

                            </div>
                            <div class="cater-name">
                                Students
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2 col-sm-4">
                        <div class="cater-box">
                            <div class="cater-icon">
                                <img src="/images/college-landing-page/msme2.png" alt="">
                            </div>
                            <div class="cater-name">
                                MSME Companies
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2 col-sm-4">
                        <div class="cater-box">
                            <div class="cater-icon">
                                <img src="/images/college-landing-page/mnc2.png" alt="">
                            </div>
                            <div class="cater-name">
                                MNC & Large Companies
                            </div>
                        </div>
                    </div>
                </div>
<!--                <div class="row">-->
<!--                    <div class="col-md-12">-->
<!--                        <div class="bottom-text">-->
<!--                            We provide good <span>Companies</span> or <span>Internships</span> prospects so your-->
<!--                            students are in good hands.-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
            </div>
        </section>

        <section class="login-banner" v-if="!this.$store.getters.getUserType">
            <div class="container">
                <div class="flex">
                    <h1>We offer placements on campus to students to help them improve their academic performance</h1>
                    <a href="javascript:;" class="raise" @click="showLoginModal()">Login Now</a>
                </div>
            </div>
        </section>
        <section class="choose-sec-bg">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h1 class="main-heading choose-heading"> Why choose My E-Campus? </h1>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <div class="choose-box">
                            <div class="choose-icon">
                                <img src="/images/college-landing-page/i1-1.png" alt="">
                                <div class="choose-title">
                                    Campus jobs placement
                                </div>
                            </div>
                            <div class="choose-text ct-list-1">
                                <ul>
                                    <li>Finding the Right Jobs for your Candidates</li>
                                    <li>Huge Pool of Companies.</li>
                                    <li>Effective and Efficient form of Placement Drive.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="choose-box">
                            <div class="choose-icon">
                                <img src="/images/college-landing-page/i3.png" alt="">
                                <div class="choose-title">
                                    Campus Internships Placement
                                </div>
                            </div>
                            <div class="choose-text ct-list-2">
                                <ul>
                                    <li>Finding the Right Internships for your Candidates</li>
                                    <li>National Pool of Opportunities.</li>
                                    <li>Effective and Efficient form of Placement Drive.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="choose-box">
                            <div class="choose-icon">
                                <img src="/images/college-landing-page/j1.png" alt="">
                                <div class="choose-title">
                                    Online Internships Assessment
                                </div>
                            </div>
                            <div class="choose-text ct-list-3">
                                <ul>
                                    <li>Special Login Page for the College/University.</li>
                                    <li>Track of Candidates Performance during Internships.</li>
                                    <li>Track of Candidates Interview Process</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="bgeEd partner-college" v-if="collegesList && collegesList.length > 0">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h5 class="heading-style">Partner Colleges</h5>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3 col-sm-4 col-xs-12" v-for="pc in collegesList">
                        <a href="javascript:void(0)">
                            <div class="college-card-partner">
                                <div class="college-img-partner">
                                    <img :src="pc.organization_logo" :alt="pc.name">
                                </div>
                                <div class="img-back-partner"></div>
                                <p v-html="pc.name"></p>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </section>
        <section class="cust-c">
            <div class="cust-vector">
                <div class="cust-vector-img"></div>
            </div>
            <div class="container">
                <div class="row">
                    <div class="col-md-7 col-md-offset-5 col-sm-6 col-sm-offset-6">
                        <div class="padd-50">
                            <div class="p-30-center">
                                <div class="cust-heading">Customization</div>
                                <div class="cust-text">
                                    Keeping in mind the needs of the students and colleges, the platform has
                                    customizable features thus putting you in the driver's seat. You can manage and use
                                    the platform in your own way.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="lay-v">
            <div class="lay-vector">
                <div class="lay-vector-img"></div>
            </div>
            <div class="container">
                <div class="row">
                    <div class="col-md-7 col-sm-6">
                        <div class="padding-30">
                            <div class="p-30-center">
                                <div class="cust-heading">Lay Career Path to your Students</div>
                                <div class="cust-text">
                                    More than 1200 companies are recruiting students for jobs and internships each day.
                                    Start your dream career today.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="feat-bg">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h1 class="main-heading">Our Features</h1>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <div class="cl-feature-box">
                            <div class="cl-feat-icon">
                                <img
                                    src="/images/college-landing-page/Schedule-Interviews-For-Your-Candidates-&-Manage-The-Dates.png">
                            </div>
                            <div class="cl-feat-name">
                                Schedule Interviews For Your Candidates & Manage The Dates
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="cl-feature-box">
                            <div class="cl-feat-icon">
                                <img
                                    src="/images/college-landing-page/Save-Time-Cost-&-Efforts-on-Finding-Companies-&-Opportunities.png">
                            </div>
                            <div class="cl-feat-name">
                                Save Time, Cost & Efforts on Finding Companies & Opportunities
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="cl-feature-box">
                            <div class="cl-feat-icon">
                                <img src="/images/college-landing-page/Find-Jobs-or-Internship-Opportunities.png">
                            </div>
                            <div class="cl-feat-name">
                                Find Jobs or Internship Opportunities
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <div class="cl-feature-box">
                            <div class="cl-feat-icon">
                                <img
                                    src="/images/college-landing-page/Keep-A-Track-of-Interview-Process-of-your-Candidates.png">
                            </div>
                            <div class="cl-feat-name">
                                Keep A Track of Interview Process of your Candidates
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="cl-feature-box">
                            <div class="cl-feat-icon">
                                <img src="/images/college-landing-page/National-Pool-Of-Opportunities.png">
                            </div>
                            <div class="cl-feat-name">
                                National Pool of Opportunities
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="cl-feature-box">
                            <div class="cl-feat-icon">
                                <img
                                    src="/images/college-landing-page/Keep-a-Track-of-Your-Candidates-&-get-Direct.png">
                            </div>
                            <div class="cl-feat-name">
                                Keep a Track of Your Candidates & get Direct Insights from the companies
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <div class="cl-feature-box">
                            <div class="cl-feat-icon">
                                <img src="/images/college-landing-page/enroll-as-many-students-as-you-want.png">
                            </div>
                            <div class="cl-feat-name">
                                enroll as many students as you want
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="cl-feature-box">
                            <div class="cl-feat-icon">
                                <img src="/images/college-landing-page/Secure-and-Rapid-Online-Process.png">
                            </div>
                            <div class="cl-feat-name">
                                Secure and Rapid Online Process
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="cl-feature-box">
                            <div class="cl-feat-icon">
                                <img src="/images/college-landing-page/Ability-to-do-an-In-depth-Company-Analysis.png">
                            </div>
                            <div class="cl-feat-name">
                                Ability to do an In-depth Company Analysis
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <div class="cl-feature-box">
                            <div class="cl-feat-icon">
                                <img src="/images/college-landing-page/Jobs-For-Students-From.png">
                            </div>
                            <div class="cl-feat-name">
                                Jobs For Students From Every profile
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="cl-feature-box">
                            <div class="cl-feat-icon">
                                <img
                                    src="/images/college-landing-page/Chose-The-Companies-and-Opportunities-that-you.png">
                            </div>
                            <div class="cl-feat-name">
                                Chose the companies and opportunities that you would like to invite into your campus
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="cl-feature-box">
                            <div class="cl-feat-icon">
                                <img src="/images/college-landing-page/Approach-companies.png">
                            </div>
                            <div class="cl-feat-name">
                                Approach companies to come to your campus
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="companies index-coms">
            <div class="container">
                <div class="">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="featured-com">
                                <h1 class="main-heading">Featured Companies</h1>
                                <div class="ac-subheading">Companies recruiting top talent from our portal.</div>
                                <!--<div class="all-coms"><a href="/organizations">View All Companies</a></div>-->
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-2 col-sm-4 col-xs-6" v-for="f in featuredComs">
                            <div class="cmp-main">
                                <div class="cmp-log">
                                    <img v-bind:src="f.organization_logo"
                                         v-bind:alt="f.name" v-bind:title="f.name">
                                </div>
                                <div class="cmp-name" v-html="f.name"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import updatesModal from './../components/updateRequiredDetail.vue';
import educationLoanWebinar from "@/components/educationLoanWebinar";
import webinarWidget from "@/components/webinarWidget";
import axios from 'axios';
import '../../public/css/featured-companies.css';

export default {
    components: {
        updatesModal,
        // webinarWidget,
        // educationLoanWebinar
    },
    data: function () {
        return {
            jobscont: [],
            featuredComs: [],
            collegesList: [],
        }
    },
    mounted() {
        if (this.validateUser()) {
            $('#updatesModal').modal('show');
        }
        var url = this.$store.getters.getDomain;
        var a = this;
        axios({
            method: 'POST',
            url: `${url}api/v2/utilities/featured-companies`
        }).then(function (response) {
            if (response['data']['response']['status'] == 200) {
                a.featuredComs = response['data']['response']['org'];
            }
        })
        a.getPreCollegeList();

        // var url = this.$store.getters.getDomain;
        //
        // var a = this;
        // var bodyFormData = new FormData();
        // if (this.$route.query.slug) {
        //     bodyFormData.set('slug', this.$route.query.slug);
        // }
        //
        // axios({
        //     method: 'POST',
        //     url: `${url}api/v2/search/jobs`,
        //     data: bodyFormData,
        //     config: {
        //         headers: {
        //             'Content-Type': 'multipart/form-data'
        //         }
        //     }
        // })
        //     .then(function (response) {
        //         if (response['data']['response']) {
        //             for (var i = 0; i < response['data']['response'].length; i++) {
        //                 a.jobscont.push(response['data']['response'][i])
        //             }
        //         } else {
        //             a.request = false;
        //         }
        //     })
        //     .catch(function (error) {
        //         console.log(error)
        //     })

    },
    methods: {
        showLoginModal() {
            $('#myModal').css({"display": "block"});
        },
        validateUser() {
            if(this.$store.getters.getUser['user_type'] == "Individual" && this.$store.getters.getUser['user_other_detail'] == false) {
                return true;
            } else {
                return false;
            }
        },
        getPreCollegeList() {
            var t = this;
            var url = this.$store.getters.getDomain;
            const headers = {
                'Authorization': "Bearer " + localStorage.getItem('token'),
                'source': localStorage.getItem('source'),
                'Content-Type': 'application/json'
            }
            axios.get(`${url}api/v2/utilities/get-companies?limit=20&filterby=`, "", {headers: headers}).then(function (response) {
                t.collegesList = response['data'];
            });
        },
    },
}
</script>
<style scoped>
.featured-com {
    text-transform: capitalize;
    margin-bottom: 30px;
}

.cmp-main {
    border: 2px solid transparent;
    text-align: center;
    padding: 10px 5px;
    margin-bottom: 20px;
    background-color: #fff;
    border-radius: 5px;
    height: 140px !important;
    cursor: pointer;
    transition: all 0.3s;
    box-shadow: 0 0 8px rgba(0, 0, 0, .2);
}

.cmp-log {
    width: 65px;
    margin: auto;
    height: 65px;
    line-height: 61px;
    transition: all 0.3s;
}

.cmp-log img {
    width: 100%;
}

.cmp-name {
    font-size: 15px;
    font-family: roboto;
    line-height: 22px;
    padding: 5px;
    font-weight: 500;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
.college-card-partner {
    position: relative;
    box-shadow: 0 0 10px rgb(0 0 0 / 10%);
    text-align: center;
    padding: 1rem;
    overflow: hidden;
    transition: 300ms all linear;
    margin-bottom: 30px;
    background-color:#fff;
}
.college-img-partner {
    position: relative;
    width: 100px;
    height: 100px;
    margin: auto;
    border-radius: 50%;
    overflow: hidden;
    padding: 3px 6px;
    background-color: #fff;
    z-index: 2;
}
.college-card-partner img {
    position: relative;
    width: 100%;
    height: 100%;
    object-fit: contain;
}
.img-back-partner{
    position: absolute;
    width: 450px;
    height: 450px;
    border:0px solid #91c8ff;
    top:22%;
    left:50%;
    border-radius: 50%;
    transform: translate(-50%, -38%);
    z-index: 1;
    transition: 300ms all linear;
}

.college-card-partner:hover > .img-back-partner{
    border-width: 500px;
}

.college-card-partner p{
    position: relative;
    z-index: 3;
    transition: 500ms all linear;
    font-weight: 700;
    line-height: 18px;
    margin-top: 1rem;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 36px;
}

.college-card-partner:hover > p{
    color: #fff;
}
.login-banner{
    width: 100%;
    height: 250px;
    background: url('https://user-images.githubusercontent.com/72601463/145973899-e22ac9fb-738e-4841-a6e8-2b5cea2f4391.png');
    background-repeat:no-repeat;
    background-size: cover;
}
.flex{
    height: 250px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: Montserrat;
}
.flex h1{
    font-size: 20px;
    max-width: 500px;
    color: #fff;
    font-weight: 600;
    line-height: 1.3;
}
.flex a{
    display: block;
    background: #FFFFFF;
    border-radius: 42px;
    padding: 15px 25px;
    font-weight: 700;
    color: #11BCE5;
    transition: all linear 0.3s;
}
.flex a:hover{
    box-shadow: 0 0 10px 8px rgba(255, 255, 255, 0.19);
    text-decoration: none;
    transition: all linear 0.3s;
}
@media only screen and (max-width: 767px){
    .login-banner{
        height: 200px;
    }
    .flex{
        height: 200px;
        flex-direction: column;
        justify-content: space-around;
        text-align: center;
    }
    .flex h1{
        font-size: 18px;
    }
}
</style>